// import { DateTime } from '../../utils/dateHelpers'
import {DateTime, normalizeDate} from '../utils/dateHelpers'

export const interactionDisplay = (column, form, resource) => {
  if (resource && form && column && column.name) {
    if (resource === 'sponsorship') {
      if (column.name === 'maxQuantity') {
        if (!form.limitAmount) {
          return true
        }
      }
    } else if (resource === 'company') {
      if (column.name === 'unionStatus' || column.name === 'companyDivision' || column.name === 'companyWorkType' || column.name === 'companyCsiCodes') {
        if (form.membership && form.membership.membershipType && form.membership.membershipType.id && form.membership.membershipType.id === 3) {
          return true
        }
      }
      if (column.name === 'companySupplyProvideService' || column.name === 'companyPrimaryAreaOfConstruction' || column.name === 'companyProductService' || column.name === 'affiliateType' || column.name === 'affiliateType') {
        if (form.membership && form.membership.membershipType && form.membership.membershipType.id && form.membership.membershipType.id !== 3) {
          return true
        }
      }
    } else if (resource === 'event') {
      if (column.name === 'teamLimit') {
        if (form.eventType && form.eventType.id === 2) {
          return false
        } else {
          return true
        }
      }
    } else if (resource === 'eventDate') {
      if (column.name === 'endDate') {
        if (form.isAllDay) {
          let newDate = DateTime(form.startDate).endOf('day')
          form.endDate = normalizeDate(newDate, 'iso')
          // form.endDate = normalizeDate(form.startDate, 'iso').endOf('day')
          return true
        }
      }
    }
  }
  return false
}

export const interactionSectionDisplay = (sectionKey, form, resource) => {
  // console.log('sectionKey', sectionKey, 'form', form, 'resource', resource)
  if (sectionKey && form && resource) {
    if (resource === 'company') {
      if (sectionKey === 'General/Specialty Contractor Info') {
        if (form.membership && form.membership.membershipType && form.membership.membershipType.id && form.membership.membershipType.id === 3) {
          return true
        }
      } else if (sectionKey === 'Affiliate Info') {
        if (form.membership && form.membership.membershipType && form.membership.membershipType.id && form.membership.membershipType.id !== 3) {
          return true
        }
      }
    }
  }
  return false
}
